import script from "./Body.vue?vue&type=script&setup=true&lang=js"
export * from "./Body.vue?vue&type=script&setup=true&lang=js"

import "./Body.vue?vue&type=style&index=0&id=4dae3c31&lang=scss"

export default script